module.exports = __webpack_public_path__ + "img/cockpit2.66b43a58.png";